var _circle, _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewardsOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5289 17.3519C24.4296 17.3519 24.38 17.2692 24.4296 17.1865C24.4296 17.1865 24.6943 16.6406 24.6943 16.2767C24.6943 15.2511 23.8672 14.4241 22.8416 14.4241C21.8161 14.4241 20.989 15.2511 20.989 16.2767C20.989 17.3023 21.8161 18.1293 22.8416 18.1293C23.2717 18.1293 23.7514 17.8647 23.7514 17.8647C23.8341 17.815 23.9168 17.8647 23.9168 17.9639V18.7248C23.9168 18.8241 23.9995 18.9068 24.0988 18.9068H24.9258C25.0251 18.9068 25.1078 18.9895 25.1078 19.0887V20.0812C25.1078 20.1805 25.0251 20.2632 24.9258 20.2632H23.9334C23.8341 20.2632 23.7514 20.1805 23.7514 20.0812V19.2707C23.7514 19.1714 23.6687 19.1053 23.5695 19.1383C23.5695 19.1383 23.189 19.2376 22.8086 19.2376C21.171 19.2376 19.8477 17.9143 19.8477 16.2767C19.8477 14.6391 21.171 13.3158 22.8086 13.3158C24.4461 13.3158 25.7695 14.6391 25.7695 16.2767C25.7695 16.6241 25.604 17.1865 25.604 17.1865C25.571 17.2857 25.4717 17.3684 25.3725 17.3684H24.4958L24.5289 17.3519Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7426 22.5789C25.94 22.5789 28.5321 19.9869 28.5321 16.7895C28.5321 13.592 25.94 11 22.7426 11C19.5452 11 16.9531 13.592 16.9531 16.7895C16.9531 19.9869 19.5452 22.5789 22.7426 22.5789Z",
    stroke: "#444444",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1502 22.5789H13.7442C13.2749 22.5789 12.8945 22.9503 12.8945 23.4083V24.6442C12.8945 25.1023 13.2749 25.4737 13.7442 25.4737H31.1502C31.6194 25.4737 31.9998 25.1023 31.9998 24.6442V23.4083C31.9998 22.9503 31.6194 22.5789 31.1502 22.5789Z",
    stroke: "#444444",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2109 25.4737H29.6846L28.301 32.3153C28.2202 32.7151 27.8902 33 27.5081 33H17.6411C17.2693 33 16.9452 32.7302 16.8531 32.3449L15.2109 25.4737Z",
    stroke: "#444444",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8402 22.5255L11.6013 16.9702C11.6013 16.9702 10.9139 16.3879 10.2808 16.9558C9.64931 17.5237 10.2802 18.5229 10.2802 18.5229L13.9024 22.5262H16.3057L16.8402 22.5255Z",
    stroke: "#444444",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7614 22.5255L34.0003 16.9702C34.0003 16.9702 34.6877 16.3879 35.3207 16.9558C35.9523 17.5237 35.3213 18.5229 35.3213 18.5229L31.6992 22.5262H29.2959L28.7614 22.5255Z",
    stroke: "#444444",
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5627,
    y: 27.9342,
    width: 0.289473,
    height: 2.60526,
    rx: 0.144737,
    stroke: "#444444",
    strokeWidth: 0.289473
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.3049,
    y: 27.9342,
    width: 0.289473,
    height: 2.60526,
    rx: 0.144737,
    stroke: "#444444",
    strokeWidth: 0.289473
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0393,
    y: 27.9342,
    width: 0.289473,
    height: 2.60526,
    rx: 0.144737,
    stroke: "#444444",
    strokeWidth: 0.289473
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsOutlined);
export default __webpack_public_path__ + "static/media/rewards_outlined.9f2820f129d362f23d018d470316715d.svg";
export { ForwardRef as ReactComponent };